import { ref, watch, type Ref } from 'vue';
import { useRoute } from 'vue-router';
import { memoizedGetProject } from '@/services/project';
import type { Project } from '@/types/project.ts';

export function useSelectedProject(): Ref<Project | null> {
  const project = ref<Project | null>(null);
  const route = useRoute();

  watch(
    () => route.params.projectId as string,
    async (newProjectId) => {
      project.value = newProjectId ? await memoizedGetProject(newProjectId) : null;
    },
    { immediate: true }
  );

  return project;
}
